export const WREG_DESKTOP_MIN_WIDTH_PX = 1100;

export const WREG_DESKTOP_QUERY = `(min-width: ${WREG_DESKTOP_MIN_WIDTH_PX}px)`;

export const isWregDesktopViewport = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(WREG_DESKTOP_QUERY).matches;
